import { render, staticRenderFns } from "./clasificador.vue?vue&type=template&id=c1d10a90&scoped=true&"
import script from "./clasificador.vue?vue&type=script&lang=ts&"
export * from "./clasificador.vue?vue&type=script&lang=ts&"
import style0 from "./clasificador.vue?vue&type=style&index=0&id=c1d10a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d10a90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c1d10a90', component.options)
    } else {
      api.reload('c1d10a90', component.options)
    }
    module.hot.accept("./clasificador.vue?vue&type=template&id=c1d10a90&scoped=true&", function () {
      api.rerender('c1d10a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Peajes/Clasificador/clasificador.vue"
export default component.exports